
import jquery from 'jquery';
import anime from 'animejs';

console.log('animejs:', anime.version);
console.log('jquery:', jquery.fn.jquery);

// load supporting files
import animations from './component/animations';
import toggles from './component/toggles';
import $ from "jquery";

jquery(function () {
    let files = [
        animations,
        toggles
    ];

    files.forEach(file => file.init.call());

  $('.menu-item-type-custom').on('click', function (event) {
    event.preventDefault();

    let element = $(event.target).closest('.menu-item-type-custom').find('a');
    let targetId = element.attr('href');

    $('html, body').animate({
      scrollTop: $(targetId).offset().top - 200
    }, 1000);
  });

  let sections = $('[data-accordion-section]');

  sections.each((index, section) => {
    let content = section.querySelector('.accordion-section-content');
    let isOpen = section.classList.contains('is-open');
    let maxHeight = isOpen ? '0px' : `${content.scrollHeight}px`;

    section.addEventListener('click', () => {
      content.animate([
        { maxHeight: maxHeight }
      ], {duration: 400, fill: 'forwards'});

      section.classList.toggle('is-open');

      sections.each((index, element) => {
        if (section !== element) {
          let otherContent = element.querySelector('.accordion-section-content');

          otherContent.animate([
            { maxHeight: '0px' }
          ], { duration: 400, fill: 'forwards' });

          element.classList.remove('is-open');
        }
      })
    });
  });
});
















